export default "__VITE_ASSET__Bpc8oIbC__"